import { TEAL, WaterProvider } from "../misc";

const BORDER_COLOR = TEAL;

export interface OptionProps {
    innerProps: any;
    getStyles: any;
    data: any;
}

export interface AsyncSearchResult {
    name: string;
}

export interface ProviderSearchResult extends AsyncSearchResult {
    provider: WaterProvider;
}

export interface GeoData extends AsyncSearchResult {
    center: Array<number>;
    geometry: {
        type: string;
        coordinates: Array<any>;
    };
    name: string;
    provider: WaterProvider;
}

export interface GeoDataFromApi {
    center: Array<number>;
    geometry: {
        type: string;
        coordinates: Array<any>;
    };
    place_name: string;
}

export interface ProviderFinderProps {
    provider?: WaterProvider;
    className?: string;
    onChange?: (item: ProviderSearchResult) => void;
    value?: ProviderSearchResult;
}

export const customStyles = {
    container: provided => ({
        ...provided,
        fontSize: "1.2rem"
    }),
    input: provided => ({
        ...provided
        // backgroundColor: "red",
        // textIndent: "2px"
    }),
    indicatorSeparator: provided => ({
        ...provided,
        display: "none"
    }),
    indicatorsContainer: provided => ({
        ...provided,
        display: "none",
        margin: "0px 5px"
    }),
    valueContainer: provided => ({
        ...provided,
        padding: "3px 8px"
    }),
    control: (provided, { isFocused }: { isFocused: boolean }) => {
        return {
            ...provided,
            borderColor: `${BORDER_COLOR}!important`,
            borderWidth: "2px",
            ...(!isFocused
                ? {
                      boxShadow: "none"
                  }
                : {
                      boxShadow: `0 0 0 .5px ${BORDER_COLOR}`
                  })
        };
    }
};
